<template>
  <ul class="members__list">
    <MembersListItem
      v-for="(member, index) in membersList"
      :member="member"
      :key="index"/>
  </ul>
</template>

<script>
import MembersListItem from '~/components/MembersListItem'

export default {
  name: 'MembersList',
  components: {
    MembersListItem
  },
  computed: {
    membersList() {
      return this.messages.index.members.membersList;
    }
  }
}
</script>



// WEBPACK FOOTER //
// components/MembersList.vue